import { authFetch } from '../auth/authFetch'

export class ApiError extends Error {
  status: number
  path: string

  constructor(status: number, path: string, message?: string) {
    super(message ?? `BFF ${path} → ${status}`)
    this.name = 'ApiError'
    this.status = status
    this.path = path
  }
}

/**
 * Typed BFF call over authFetch: authFetch refreshes + attaches the bearer token;
 * this throws ApiError on non-2xx and parses JSON. Pass a PATH, never a full URL —
 * authFetch always targets VITE_BFF_URL, so the token is never leaked to another
 * origin. For non-BFF/third-party requests use plain fetch() instead.
 */
export async function bff<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await authFetch(path, init)
  if (!res.ok) {
    const errorBody = await res.json().catch(() => null)
    const errorMsg =
      errorBody?.detail ||
      errorBody?.message ||
      errorBody?.error ||
      (typeof errorBody === 'string' ? errorBody : undefined)
    throw new ApiError(
      res.status,
      path,
      errorMsg ? `BFF ${path} → ${res.status}: ${errorMsg}` : undefined
    )
  }
  return res.json() as Promise<T>
}
